module.exports = __webpack_public_path__ + "img/9cf0d8cecfdf4b64bddc62c931892925-1024.a5596dfd.jpg";